export const ALLSEATS = 'Für alle Sitze';
export const FRONTSEAT = 'Vordersitze';
export const SECONDROW = '2. Sitzreihe (hinten)'

export const seatPositions = [ALLSEATS];
